import * as types from "./act_actionTypes";

const initialState = {
    recent_activity_data: [],

    loading: true,
};

const actReducers = (state = initialState, action) => {
    switch (action.type) {
        case types.get_recent_activities:
            return {
                ...state,
                recent_activity_data: action.payload,
                loading: false
            }
        default:
            return state;
    }
};

export default actReducers;